import { lazy } from 'react'

export const ArchivePageAsync = lazy(() => import('./ArchivePage'))
